module.exports = __webpack_public_path__ + "img/children.5152ffd5.jpg";